import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { AuthUser } from './auth.model';

import * as storage from "./storage";

export interface AuthState {
  token: string;
  user: AuthUser
}

export function createInitialState(): AuthState {
  return {
    token: null,
    user: null,
    ...storage.getSession(),
  }
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'auth' })
export class AuthStore extends Store<AuthState> {

  constructor() {
    super(createInitialState());
  }

  login(session: AuthState) {
    this.update(session);
    storage.saveSession(session);
  }

  logout() {
    storage.clearSesssion();
    this.update(createInitialState());
  }

  updateProfile( user: AuthUser ) {
    const session = storage.getSession();

    this.update( state => ({
      ...state,
      user
    }));
    
    storage.saveSession({
      ...session,
      user
    })
  }

}
